import { Editor, Element, Transforms } from 'slate';
import { type EventHandlerParams } from './types';
import NodeUtils from '../../../AhaEditorUtils/NodeUtils';

const handleBackspace = ({
  editor,
  event,
  currentBlock,
  isVoid,
}: EventHandlerParams) => {
  if (!isVoid) return;

  event.preventDefault();
  const [, currentBlockPath] = currentBlock;

  const previousBlock = NodeUtils.previousSibling(editor, currentBlockPath, {
    match: (n) => Element.isElement(n) && Editor.isBlock(editor, n),
  });

  Transforms.removeNodes(editor, {
    at: currentBlockPath,
  });

  if (previousBlock) {
    const [, previousBlockPath] = previousBlock;
    Transforms.select(editor, Editor.end(editor, previousBlockPath));
  }

  return true;
};

export default handleBackspace;
